<template>

    <form ref="candidato-form-realizar-entrevista" v-on:submit.prevent="executeEdit(entrevista)" novalidate>

        <div class="card" v-if="candidato">
            <div class="card-body">

                <div class="row mb-2">
                    <div class="col-md-8 ">
                        <h6 class="card-subtitle text-muted">Candidato</h6>
                        <h5 class="card-title">{{candidato.colaborador.nmCompleto}}</h5>
                    </div>
                    <div class="col-md-4 ">
                        <h6 class="card-subtitle text-muted">Cargo</h6>
                        <h5 class="card-title">{{candidato.cargo.nmCargo}}</h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Teste realizado em</h6>
                        <h5 class="card-title">{{candidato.teste.dtTermino}}</h5>
                    </div>
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Nota Obtida</h6>
                        <h5 class="card-title">{{candidato.teste.nota}} de {{candidato.teste.avaliacao.notaAprovacao}} pontos</h5>
                    </div>
                    <div class="col-md-4">
                        <h6 class="card-subtitle text-muted">Situação</h6>
                        <h5 class="card-title">{{candidato.teste.situacaoTeste.nome}}</h5>
                    </div>
                </div>

            </div>
        </div>

        <br />

        <ul class="list-group">
            <li class="list-group-item" v-for="entrevistaConceito in entrevista.collectionEntrevistaConceito" v-bind:key="entrevistaConceito.conceitoId">
                <div class="row">
                    <div class="col-md-7">
                        {{entrevistaConceito.conceito.nome}}
                        <i class="fa fa-question-circle" v-b-tooltip.right :title="entrevistaConceito.conceito.descricao" v-if="entrevistaConceito.conceito.descricao"></i>
                    </div>
                    <div class="col-md-4">
                        <div class="btn-group btn-group-toggle float-right" v-b-tooltip.hover title="Insira a nota para o conceito">
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 1, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 1 }">
                                <input type="radio" v-model="entrevistaConceito.avaliacao" value="1"> 1
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 2, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 2 }">
                                <input type="radio" v-model="entrevistaConceito.avaliacao" value="2"> 2
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 3, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 3 }">
                                <input type="radio" v-model="entrevistaConceito.avaliacao" value="3"> 3
                            </label>
                            <label class="btn btn-sm border-success" v-bind:class="{ active: entrevistaConceito.avaliacao == 4, 'btn btn-sm btn-success': entrevistaConceito.avaliacao == 4 }">
                                <input type="radio" v-model="entrevistaConceito.avaliacao" value="4"> 4
                            </label>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <br />

        <div class="row">
            <div class="form-group col-md-12">
                <label>Observações</label>
                <textarea type="text"
                          class="form-control"
                          name="observacoes"
                          v-model="entrevista.observacoes"
                          placeholder="Insira informações complementares para finalizar esta entrevista" />
            </div>
        </div>

        <br />

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>

        <button type="button" class="btn btn-success float-right" @click="executeEdit(entrevista, 'contratar')">
            <span>Contratar</span>
        </button>
        <button type="button" class="btn btn-danger float-right" @click="executeEdit(entrevista, 'dispensar')">
            <span>Não Contratar</span>
        </button>
        <button type="button" class="btn btn-primary float-right" @click="executeEdit(entrevista)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "candidato-form-realizar-entrevista",
        mixins: [base],
        props: { candidatoId: Number, entrevistaId: Number },
        data: () => ({

            entrevista: {},
            candidato: null,

            form: "candidato-form-realizar-entrevista",

        }),

        methods: {

            executeEdit: function (model, status) {

                if (this.formValidate() == false) return;

                if (status == 'contratar') model.attributeBehavior = "SalvarRealizacaoContratar";
                else if (status == 'dispensar') model.attributeBehavior = "SalvarRealizacaoDispensar";
                else model.attributeBehavior = "SalvarRealizacao";

                this.showLoading();

                new Api('entrevista').put(model).then(data => {
                    let _data = data.data;
                    if (status == 'dispensar') {
                        this.defaultSuccessResult("Entrevista realizada com sucesso e candidato dispensado.");
                    }
                    else if (status == 'contratar') {
                        this.defaultSuccessResult("Entrevista realizada com sucesso, e colaborador contratado.");
                        _data.doOpenConfigurarAcesso = true;
                        _data.candidatoId = this.candidatoId;
                        new Api('colaboradorexpprofissional').post({
                            attributeBehavior: "SalvaExperienciaContratacao",
                            escolaId: this.candidato.escolaId,
                            colaboradorId: this.candidato.colaboradorId,
                            nmEmpresa: 'CNA',
                            dtInicio: new Date(),
                            cargoId: this.candidato.cargoId,
                            ehInterno: true,
                        }).then(() => { })
                    }
                    else
                        this.defaultSuccessResult("Entrevista realizada com sucesso.");

                    this.$emit('on-saved', _data)
                }, err => {
                    this.defaultErrorResult(err);
                })

            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

        },

        mounted() {
            new Api('entrevista').get({ entrevistaId: this.entrevistaId }).then(data => {
                this.entrevista = data.dataList[0];
            }, err => { this.defaultErrorResult(err); })

            new Api('candidato').get({ candidatoId: this.candidatoId }).then(data => {
                this.candidato = data.dataList[0];
            }, err => { this.defaultErrorResult(err); })

        }
    };
</script>
